module.exports = __webpack_public_path__ + "img/m_r.c2b6e6c1.png";